import React, { useState } from "react";
import "./AudioRec.css";

export default function AudioRec({ handleSaveAudio }) {
  const [recording, setRecording] = useState(null);
  const [chunks, setChunks] = useState([]);

  const handleDataAvailable = (event) => {
        chunks.push(event.data);
    };

  async function startRecording() {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      // const mimeType = "audio/mp4"

      const mediaRecorder = new MediaRecorder(stream);
      mediaRecorder.ondataavailable = handleDataAvailable;

      // mediaRecorder.ondataavailable = (e) => {
      //   if (e.data.size > 0) {
      //     setChunks((prev) => [...prev, e.data]);
      //   }
      // };

      mediaRecorder.onstop = () => {
        const blob = new Blob(chunks, { type: "audio/wav" });
        const file = new File([blob], "record.wav");
        console.log('file', file)
        handleSaveAudio(file); // <-- передаём именно File, а не URL
      };


      mediaRecorder.start();
      setRecording(mediaRecorder);
    } catch (err) {
      console.error("Failed to start recording", err);
      alert("Ошибка доступа к микрофону");
    }
  }

  function stopRecording() {
    if (recording) {
      recording.stop();
      setRecording(null);
    }
  }

  return (
    <button
      className="audio-rec-btn"
      onClick={recording ? stopRecording : startRecording}
      style={{
        fontSize: "24px",
        padding: "5px 10px",
        cursor: "pointer",
        background: "none",
        border: "none",
      }}
    >
      {recording ? "⏹️" : "🎤"}
    </button>
  );
}
